// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { ComposedModal, ModalBody, ModalHeader } from '@carbon/react';
import { bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

import ModalManager from 'Containers/ModalManager/ModalManager';
import { NETWORK_ONE_DISTRIBUTION } from 'Constants';

import Logo from 'Assets/images/logo-nod@2x.png';

const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem !important;
  text-align: center;

  p {
    padding-right: 0 !important;
    white-space: pre-line;
  }

  img {
    transform: scale(0.5);
  }

  button {
    min-width: 0;
    width: 100%;
    height: 50px;
    padding: 0;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    border-color: inherit;
  }
`;

const ProductsUnavailableModalComponent = ({ isRecentlyAdded, pricesAvailableToday }) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalManager open={ isRecentlyAdded || pricesAvailableToday }>
        <ComposedModal
          size="sm"
          className="ProductsUnavailableModal"
          selectorPrimaryFocus=".cds--modal-content"
        >
          <ModalHeader />
          <StyledModalBody>
            <img src={ Logo } alt={ NETWORK_ONE_DISTRIBUTION } />
            <h2>{t(`errors.productsUnavailable.${ isRecentlyAdded ? 'isRecentlyAdded' : 'pricesAvailableToday' }`)}</h2>
          </StyledModalBody>
        </ComposedModal>
      </ModalManager>
    </>
  );
};

ProductsUnavailableModalComponent.propTypes = {
  isRecentlyAdded: bool,
  pricesAvailableToday: bool,

};

export default ProductsUnavailableModalComponent;
